import { useEffect, useState } from "react";
import { api } from "../api.ts";
import type { ScheduleCur, ScheduleSaveResult } from "../types.ts";

export function ScheduleWidget({ ticketId, cur, onSaved, embedded = false }: {
  ticketId: number;
  cur: ScheduleCur;
  onSaved: (result: ScheduleSaveResult) => void;
  embedded?: boolean;
}) {
  const toLocal = (s?: string | null) => {
    if (!s) return "";
    const d = new Date(s);
    const p = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
  };
  const [at, setAt] = useState(toLocal(cur.scheduled_at));
  const [tech, setTech] = useState(cur.scheduled_tech || "");
  const [status, setStatus] = useState(cur.visit_status || "unscheduled");
  const [note, setNote] = useState(cur.schedule_note || "");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    setAt(toLocal(cur.scheduled_at));
    setTech(cur.scheduled_tech || "");
    setStatus(cur.visit_status || "unscheduled");
    setNote(cur.schedule_note || "");
  }, [cur.scheduled_at, cur.scheduled_tech, cur.visit_status, cur.schedule_note]);

  const save = async () => {
    setBusy(true);
    try {
      const result = await api<ScheduleSaveResult>(`/support/tickets/${ticketId}/schedule`, {
        method: "PATCH",
        body: JSON.stringify({
          scheduled_at: at ? new Date(at).toISOString() : null,
          scheduled_tech: tech,
          visit_status: status,
          schedule_note: note,
        }),
      });
      setErr("");
      onSaved(result);
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  const inp = {
    padding: "0.35rem 0.5rem", borderRadius: 6, border: "1.5px solid var(--border,#e0e4e0)",
    fontFamily: "inherit", fontSize: "0.82rem",
  } as const;
  const shellStyle: React.CSSProperties = embedded
    ? {}
    : { marginTop: "0.5rem", border: "1px solid var(--border,#e0e4e0)", borderRadius: 8, padding: "0.6rem 0.75rem" };

  return (
    <div style={shellStyle}>
      {!embedded && <div style={{ fontWeight: 700, fontSize: "0.82rem", marginBottom: "0.4rem" }}>現場予定</div>}
      <div style={{ display: "flex", gap: "0.4rem", flexWrap: "wrap", alignItems: "center" }}>
        <input type="datetime-local" value={at} onChange={(e) => setAt(e.target.value)} style={inp} />
        <input value={tech} onChange={(e) => setTech(e.target.value)} placeholder="担当" style={{ ...inp, width: 100 }} />
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={inp}>
          <option value="unscheduled">未定</option>
          <option value="scheduled">予定</option>
          <option value="done">完了</option>
          <option value="canceled">中止</option>
        </select>
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="メモ" style={{ ...inp, flex: 1, minWidth: 80 }} />
        <button type="button" onClick={save} disabled={busy} className="support-btn-primary">{busy ? "保存中" : "保存"}</button>
      </div>
      {err && <div style={{ color: "var(--danger,#e53935)", fontSize: "0.75rem", marginTop: "0.3rem" }}>{err}</div>}
    </div>
  );
}
